const features = [
  {
    icon: 'ri-shield-check-line',
    title: '高清不卡顿',
    desc: '全站采用高速CDN加速，1080P高清画质流畅播放，告别缓冲等待，观影体验拉满。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '资源全覆盖',
    desc: '聚合香蕉视频、红桃视频、91视频等热门站点，电影、电视剧、综艺、动漫一网打尽。',
  },
  {
    icon: 'ri-timer-line',
    title: '更新超及时',
    desc: '7x24小时实时监控更新，新片上线第一时间同步，追剧党再也不用苦等资源。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '完美适配电脑、平板、手机等设备，随时随地畅享影视，通勤路上也能追剧。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">平台优势</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">为什么选择51视频？四大核心优势为你保驾护航</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="text-center p-6 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-200"
            >
              <div className={`w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-xl ${
                idx === 0 ? 'bg-primary-100 text-primary-600' :
                idx === 1 ? 'bg-accent-100 text-accent-700' :
                idx === 2 ? 'bg-secondary-100 text-secondary-700' :
                'bg-primary-100 text-primary-600'
              }`}>
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}